import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { dateFormatter } from '../../../../../utils';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  row1: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableColHeader: {
    width: '14.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0',
    padding: 5
  },
  tableCol: {
    width: '13.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 5
  },
  tableCellHeader: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center',
    marginTop: '2%'
  },
  tableCell: {
    fontSize: 10
  },
  columnContent: {
    width: '15%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const COLORS = ['#ffffff', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const IndentMedicineIssueReportPdf = ({ data }) => {
  console.log(data);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  return (
    <PDFViewer width="100%" height="100%" showToolbar>
      <Document title={`Indent Medicine Issue Report`}>
        <Page size="A4" style={styles.page}>
          <PDFImage
            src="/logo_Hospital_m.jpeg"
            style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
          />
          <View style={styles.row}>
            <Text content="Indent Medicine Issue" style={{ fontSize: '12px', margin: '0 auto' }} />
          </View>

          {/* Indent Info */}
          <View style={styles.contentContainer}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Issue No.                   :     " style={styles.textBold} />
                <Text content={`${data.issue_no}`} />
              </View>
              <View style={styles.row}>
                <Text content="Indent No.                  :     " style={styles.textBold} />
                <Text content={`${data.indent_no}`} />
              </View>
              <View style={styles.row}>
                <Text content="UHID NO.                  :     " style={styles.textBold} />
                <Text content={`${data.uhid}`} />
              </View>
              <View style={styles.row}>
                <Text content="Indent Date/Time      :     " />
                <Text content={`${data.indent_date}, ${data.indent_time || ''}`} />
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Patient Name            :    " />
                <Text content={`${data.patient}`} />
              </View>
              <View style={styles.row}>
                <Text content="IPD No.                     :    " />
                <Text content={`${data.ipd_no}`} />
              </View>
              <View style={styles.row}>
                <Text content="Indent By                  :    " />
                <Text content={`${data.indent_by || '-'}`} />
              </View>
              <View style={styles.row}>
                <Text content="Remarks                   :     " />
                <Text content={`${data.remarks || '-'}`} />
              </View>
            </View>
          </View>

          {/* Product Table */}
          <View style={styles.row1}>
            <Text style={{ ...styles.columnHeader, width: '10%' }} content="Sr No." />
            <Text style={{ ...styles.columnHeader, width: '30%' }} content="Product" />
            <Text style={{ ...styles.columnHeader, width: '10%' }} content="Quantity" />
            <Text style={{ ...styles.columnHeader, width: '10%' }} content="Rate" />
            <Text style={{ ...styles.columnHeader, width: '15%' }} content="Amount" />
            <Text style={{ ...styles.columnHeader, width: '15%' }} content="Expiry Date" />
            <Text style={{ ...styles.columnHeader, width: '10%' }} content="Batch No." />
          </View>
          {data.productDetails &&
            data.productDetails.map((productDetail, index) => (
              <View key={index} style={{ ...styles.row1, backgroundColor: COLORS[index % COLORS.length] }}>
                <Text style={{ ...styles.columnContent, width: '10%' }} content={index + 1} />
                <Text
                  style={{ ...styles.columnContent, textAlign: 'start', width: '30%' }}
                  content={productDetail.product || '-'}
                />
                <Text style={{ ...styles.columnContent, width: '10%' }} content={productDetail.quantity || '-'} />
                <Text style={{ ...styles.columnContent, width: '10%' }} content={productDetail.rate || '-'} />
                <Text
                  style={{ ...styles.columnContent, width: '15%' }}
                  content={productDetail.rate * productDetail.quantity || '-'}
                />
                <Text style={{ ...styles.columnContent, width: '15%' }} content={formatDate(productDetail.exp_date)} />
                <Text style={{ ...styles.columnContent, width: '10%' }} content={productDetail.batch_no || '-'} />
              </View>
            ))}

          {/* Tax and Total */}
          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={{ marginTop: '50px' }}>
                <Text content={`Received With Thanks From ${data.patient}`} />
              </View>
            </View>

            <View style={{ ...styles.row }}>
              <View style={styles.row}>
                <Text content="Bill Amount : " />
                <Text content={`${data.total_amt || '-'}`} />
              </View>
              <View style={{ ...styles.row, marginLeft: '10%' }}>
                <Text content="Balance : " />
                <Text content={`${data.balance || '-'}`} />
              </View>
            </View>
          </View>
          <View style={{ marginTop: '20px', marginLeft: '10%' }}>
            <Text content="Authorised Signatory        :" />
            <Text style={styles.textUnderlined} />
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};
